import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export const SPORTS_CONFIG = {
    cfb: {
        id: 'cfb',
        name: 'College Football',
        shortName: 'CFB',
        icon: 'fas fa-football-ball',
        isActive: true,
        seasons: {
            current: '2025',
            available: ['2020', '2021', '2022', '2023', '2024', '2025']
        },
        gameFormat: {
            hasSpread: true,
            hasTotal: true,
            hasMoneyline: true
        },
        schedule: {
            regularSeasonWeeks: 15,
            playoffWeeks: 4,
            seasonStart: '08-24',
            seasonEnd: '01-20'
        }
    },
    nfl: {
        id: 'nfl',
        name: 'National Football League',
        shortName: 'NFL',
        icon: 'fas fa-football-ball',
        isActive: true,
        seasons: {
            current: '2025',
            available: ['2020', '2021', '2022', '2023', '2024']
        },
        gameFormat: {
            hasSpread: true,
            hasTotal: true,
            hasMoneyline: true
        },
        schedule: {
            regularSeasonWeeks: 18,
            playoffWeeks: 4,
            seasonStart: '09-05',
            seasonEnd: '02-15'
        }
    },
    nba: {
        id: 'nba',
        name: 'National Basketball Association',
        shortName: 'NBA',
        icon: 'fas fa-basketball-ball',
        isActive: true,
        seasons: {
            current: '2024-25',
            available: ['2020-21', '2021-22', '2022-23', '2023-24', '2024-25']
        },
        gameFormat: {
            hasSpread: true,
            hasTotal: true,
            hasMoneyline: true
        },
        schedule: {
            regularSeasonWeeks: 26,
            playoffWeeks: 8,
            seasonStart: '10-15',
            seasonEnd: '06-20'
        }
    },
    mlb: {
        id: 'mlb',
        name: 'Major League Baseball',
        shortName: 'MLB',
        icon: 'fas fa-baseball-ball',
        isActive: true,
        seasons: {
            current: '2025',
            available: ['2020', '2021', '2022', '2023', '2024', '2025']
        },
        gameFormat: {
            hasSpread: false,
            hasTotal: true,
            hasMoneyline: true
        },
        schedule: {
            regularSeasonWeeks: 26,
            playoffWeeks: 4,
            seasonStart: '03-28',
            seasonEnd: '10-30'
        }
    },
    cbb: {
        id: 'cbb',
        name: 'College Basketball',
        shortName: 'CBB',
        icon: 'fas fa-basketball-ball',
        isActive: true,
        seasons: {
            current: '2024-25',
            available: ['2020-21', '2021-22', '2022-23', '2023-24', '2024-25']
        },
        gameFormat: {
            hasSpread: true,
            hasTotal: true,
            hasMoneyline: true
        },
        schedule: {
            regularSeasonWeeks: 20,
            playoffWeeks: 4,
            seasonStart: '11-06',
            seasonEnd: '04-08'
        }
    },
    nhl: {
        id: 'nhl',
        name: 'National Hockey League',
        shortName: 'NHL',
        icon: 'fas fa-hockey-puck',
        isActive: true,
        seasons: {
            current: '2024-25',
            available: ['2020-21', '2021-22', '2022-23', '2023-24', '2024-25']
        },
        gameFormat: {
            hasSpread: false,
            hasTotal: true,
            hasMoneyline: true
        },
        schedule: {
            regularSeasonWeeks: 26,
            playoffWeeks: 8,
            seasonStart: '10-08',
            seasonEnd: '06-30'
        }
    }
};
const SportContext = createContext(undefined);
export const useSport = () => {
    const context = useContext(SportContext);
    if (!context) {
        throw new Error('useSport must be used within a SportProvider');
    }
    return context;
};
export const SportProvider = ({ children }) => {
    // Read the saved sport on first render, so a refreshed game page routes to the right sport immediately
    const [currentSport, setCurrentSport] = useState(() => {
        try {
            const savedSportId = localStorage.getItem('selectedSport');
            if (savedSportId && SPORTS_CONFIG[savedSportId])
                return SPORTS_CONFIG[savedSportId];
        }
        catch {
            // storage unavailable: fall back to CFB
        }
        return SPORTS_CONFIG.cfb;
    });
    const activeSports = Object.values(SPORTS_CONFIG).filter(sport => sport.isActive);
    const allSports = Object.values(SPORTS_CONFIG);
    // Save sport preference to localStorage
    const handleSetCurrentSport = (sport) => {
        setCurrentSport(sport);
        localStorage.setItem('selectedSport', sport.id);
    };
    const value = {
        currentSport,
        setCurrentSport: handleSetCurrentSport,
        activeSports,
        allSports
    };
    return (_jsx(SportContext.Provider, { value: value, children: children }));
};
export default SportContext;
